import { ProductPageProps } from './ProductPage.types'
import { PageWrapper } from '@otomoro/components/layout/PageWrapper'
import { FlexibleContent, FlexibleContentProps } from '@otomoro/components/shared/FlexibleContent'
import { Headline } from '@otomoro/components/shared/Headline'
import Script from 'next/script'

type SanityBlockType = { _type: string }

export default function ProductPage({ data }: ProductPageProps) {
	if (!data) {
		return (
			<div className="text-center">
				Please start editing your ProductDetails document to see the preview!
			</div>
		)
	}

	return (
		<PageWrapper noPb>
			<Headline
				border
				headlineText={data.headline}
				subheadline={data.subHeadline}
				headlineSVG={data.headlineSVG}
			></Headline>
			<FlexibleContent blocks={data.flexibleContent as FlexibleContentProps['blocks']} />

			<Script
				async
				strategy="afterInteractive"
				type="module"
				src="https://unpkg.com/@google/model-viewer@^2.1.1/dist/model-viewer.min.js"
			/>
		</PageWrapper>
	)
}
